// Salt-okunur SÜRE rozeti — Kolay/Teknik/Aydınlık/Profesyonel/Pano
// arayüzlerinde alt görev sürelerini göstermek için. Düzenleme burada YOK
// (düzenleme yalnızca Sertex kartındaki SubtaskDates bileşeninde).
// Rol/ekip görünümü kapısı YOKTUR: her kullanıcıda görünür.
import { taskDurationTotals, TOTAL_LABELS } from "../../lib/subtaskDuration";

// Görev düzeyi toplam süre. `mode` verilmezse "Açılıştan bitişe" gösterilir.
// Alt görevlerin hiç tarihi yoksa HİÇBİR ŞEY çizilmez (uydurma sayı yok).
export const TaskDurationBadge = ({ task, mode = "open_to_close", light = false, testId }) => {
  const totals = taskDurationTotals(task);
  if (!totals.hasDates) return null;
  const cur = mode === "work" ? totals.work : totals.openToClose;
  const tone = totals.anomaly
    ? (light ? "text-rose-600" : "text-rose-300")
    : cur.ongoing
      ? (light ? "text-sky-700" : "text-sertex-cyan")
      : (light ? "text-violet-700" : "text-violet-200");
  return (
    <span
      data-testid={testId || `task-duration-badge-${task.id}`}
      title={`${TOTAL_LABELS[mode]}${totals.anomaly ? " · tarih hatası var" : ""}`}
      className={`inline-flex max-w-full items-center gap-1 truncate text-[11px] ${tone}`}
    >
      <span aria-hidden="true">⏱</span>
      <span className="truncate">{totals.anomaly ? `${cur.text} ⚠` : cur.text}</span>
    </span>
  );
};

export default TaskDurationBadge;
